import {
  BUSINESS_TYPES,
  SPEED_TYPES,
} from "../../settings/settingsv2/ssd/SsdSettingsConstant";
export const days = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];
export const tasks = ["INDUCT", "SORT", "STAGE"];
export const timeBreaks = ["BREAK1", "LUNCH", "BREAK2"];
export const taskPlan = "taskPlan";
export const breaks = "breaks";
export const induct = "INDUCT";
export const sort = "SORT";
export const stage = "STAGE";
export const break1 = "BREAK1";
export const lunch = "LUNCH";
export const break2 = "BREAK2";
export const startTime = "startTime";
export const endTime = "endTime";
export const targetMap = "targetMap";
export const NODE_TPH = "NODE_TPH";
export const INDUCT_PPH = "INDUCT_PPH";
export const STOW_PPH = "STOW_PPH";
export const dayMaxHour = 23;
export const dayMinHour = 0;
export const stringDay = "January 1, 2020 ";
export const MODAL_RESET = "RESET";
export const MODAL_SUCCESS = "SUCCESS";
export const MODAL_ERROR = "ERROR";
export const MIN_RESOURCES = 1;
export const MAX_RESOURCES = 100;
export const MAX_RESOURCES_RATE_BASED = 10;
export const RESET_TIME_OVERLAP = "overlap_with_reset_time";
export const wip = {
  "Stow WIP Compliance Target (%)": "WIP_TARGET",
  "Stow WIP Upper (minutes)": "STOW_WIP_UPPER",
  "Stow WIP Lower (minutes)": "STOW_WIP_LOWER",
};
export const flowHeaders = ["WIP Metric", "Current", "Override"];
export const flowIdentifierConstant = "GLOBAL";

export const associateOnlyProcesses = ["Stow", "Induct", "Pick & Stage - Pick"];

export const indirectHCProcessMap = {
  Pusher: {
    processName: "Pusher",
    processCode: "PUSHER",
    process: "Pusher",
    isAutoProcess: false,
  },
  Diverter: {
    processName: "Diverter",
    processCode: "DIVERTER",
    process: "Diverter",
    isAutoProcess: false,
  },
  "Induct Line Loader": {
    processName: "Induct Line Loader",
    processCode: "INDUCT_LINE_LOADER",
    process: "Induct Line Loader",
    isAutoProcess: false,
  },
  "Inbound Dock W/S": {
    processName: "Inbound Dock W/S",
    processCode: "INBOUND_DOCK_WS",
    process: "Inbound Dock W/S",
    isAutoProcess: false,
  },
  "Auto Scan Induct Loader": {
    processName: "Auto Scan Induct Loader",
    processCode: "AUTO_SCAN_INDUCT_LOADER",
    process: "Auto Scan Induct Loader",
    isAutoProcess: false,
  },
  "Auto Scan Pusher": {
    processName: "Auto Scan Pusher",
    processCode: "AUTO_SCAN_PUSHER",
    process: "Auto Scan Pusher",
    isAutoProcess: false,
  },
  "Pick to Buffer": {
    processName: "Pick to Buffer",
    processCode: "PICK_TO_BUFFER",
    process: "Pick to Buffer",
    isAutoProcess: false,
  },
  "Non-Scan Stow": {
    processName: "Non-Scan Stow",
    processCode: "NON_SCAN_STOW",
    process: "Non-Scan Stow",
    isAutoProcess: false,
  },
  "Non-Con Manual Handling": {
    processName: "Non-Con Manual Handling",
    processCode: "NON_CON_MANUAL_HANDLING",
    process: "Non-Con Manual Handling",
    isAutoProcess: false,
  },
  "Sort Problem Solve": {
    processName: "Sort Problem Solve",
    processCode: "SORT_PROBLEM_SOLVE",
    process: "Sort Problem Solve",
    isAutoProcess: false,
  },
  "Auto Divert Straightener": {
    processName: "Auto Divert Straightener",
    processCode: "AUTO_DIVERT_STRAIGHTENER",
    process: "Auto Divert Straightener",
    isAutoProcess: false,
  },
  "UTR Dispatch": {
    processName: "UTR Dispatch",
    processCode: "UTR_DISPATCH",
    process: "UTR Dispatch",
    isAutoProcess: false,
  },
  "Yard Assist and Cart Handling": {
    processName: "Yard Assist and Cart Handling",
    processCode: "YARD_ASSIST_AND_CART_HANDLING",
    process: "Yard Assist and Cart Handling",
    isAutoProcess: false,
  },
  "Pick Stage Problem Solve": {
    processName: "Pick Stage Problem Solve",
    processCode: "PICK_STAGE_PROBLEM_SOLVE",
    process: "Pick Stage Problem Solve",
    isAutoProcess: false,
  },
  "Pick Stage & Dispatch Problem Solve": {
    processName: "Pick Stage & Dispatch Problem Solve",
    processCode: "PICK_STAGE_AND_DISPATCH_PROBLEM_SOLVE",
    process: "Pick Stage & Dispatch Problem Solve",
    isAutoProcess: false,
  },
  "Non-Scan Pick & Stage": {
    processName: "Non-Scan Pick & Stage",
    processCode: "NON_SCAN_PICK_AND_STAGE",
    process: "Non-Scan Pick & Stage",
    isAutoProcess: false,
  },
  "Yard Marshall": {
    processName: "Yard Marshall",
    processCode: "YARD_MARSHALL",
    process: "Yard Marshall",
    isAutoProcess: false,
  },
  "Empty Cart Returns": {
    processName: "Empty Cart Returns",
    processCode: "EMPTY_CART_RETURNS",
    process: "Empty Cart Returns",
    isAutoProcess: false,
  },
  "Learning Coordinator": {
    processName: "Learning Coordinator",
    processCode: "LEARNING_COORDINATOR",
    process: "Learning Coordinator",
    isAutoProcess: false,
  },
  "UTR OPS Supervisor / SA": {
    processName: "UTR OPS Supervisor / SA",
    processCode: "UTR_OPS_SUPERVISOR",
    process: "UTR OPS Supervisor / SA",
    isAutoProcess: false,
  },
  Safety: {
    processName: "Safety",
    processCode: "SAFETY",
    process: "Safety",
    isAutoProcess: false,
  },
  "Training Ambassador": {
    processName: "Training Ambassador",
    processCode: "TRAINING_AMBASSADOR",
    process: "Training Ambassador",
    isAutoProcess: false,
  },
  "Stow Bag Replenishment": {
    processName: "Stow Bag Replenishment",
    processCode: "STOW_BAG_REPLENISHMENT",
    process: "Stow Bag Replenishment",
    isAutoProcess: false,
  },
  "Auto Diverter": {
    processName: "Auto Diverter",
    processCode: "AUTO_DIVERTER",
    process: "Auto Diverter",
    isAutoProcess: true,
    parentProcess: "Diverter",
  },
  "Auto Inductor": {
    processName: "ASL Induct Machine",
    processCode: "AUTO_INDUCTOR",
    process: "Auto Inductor",
    isAutoProcess: true,
    parentProcess: "Induct",
  },
  Induct: {
    processName: "Induct",
    processCode: "INDUCT",
    process: "Induct",
    isAutoProcess: false,
  },
  Stow: {
    processName: "Stow",
    processCode: "STOW",
    process: "Stow",
    isAutoProcess: false,
  },
  "Pick & Stage - Pick": {
    processName: "Pick & Stage - Pick",
    processCode: "PICK_AND_STAGE_PICK",
    process: "Pick & Stage - Pick",
    isAutoProcess: false,
  },
};
export const INDIRECT_HC_RULE_TYPE_VOLUME = "VOLUME";
export const INDIRECT_HC_RULE_TYPE_RATIO = "RATIO";
export const INDIRECT_HC_RULE_TYPE_FIXED_HC = "FIXED_HC";
export const MAX_TIME_INTERVALS_COUNT = 5;

export const INDIRECT_HC_FIELD_NAME_RULE_TYPE = "ruleType";
export const INDIRECT_HC_FIELD_NAME_RATIO_TO_ASSOCIATED_PROCESS =
  "ratioToAssociatedProcess";
export const INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS = "associatedProcess";
export const INDIRECT_HC_FIELD_NAME_VOLUME = "volume";
export const INDIRECT_HC_FIELD_NAME_RATE = "rate";
export const INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES = "minAssociates";
export const INDIRECT_HC_FIELD_NAME_TIME_INTERVAL = "timeInterval";
export const INDIRECT_HC_FIELD_NAME_START_TIME = "localStartTime";
export const INDIRECT_HC_FIELD_NAME_END_TIME = "localEndTime";
export const INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION =
  "headcountRuleConfiguration";
export const FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES =
  "timeIntervalsWithMinAssociates";
export const CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES =
  "fixedHCTimeIntervalsWithMinAssociates";
export const PARENT_PROCESS = "parentProcess";
export const DISPATCH = "DISPATCH";
export const DEFAULT_SECONDS = "00";
export const TIME_INTERVALS = "timeIntervals";
export const ZERO_ZERO_ZERO_ZERO_CLOCK = "00:00:00";
export const DEFAULT_CYCLE = "CYCLE_1";
export const PROCESS_RULES = "processRules";
export const PROCESS = "process";
export const CYCLE = "cycleName";

export const SSD_BREAK_TYPE = {
  UNPAID: "unpaid",
  PAID: "paid",
  SOS_STANDUP: "sos_standup",
  SITE_SHUTDOWN: "site_shutdown",
};

export const SSD_SHIFT_NAME = {
  SHIFT_P1: "shiftp1",
  SHIFT_P2: "shiftp2",
  SHIFT_P3: "shiftp3",
  SHIFT_P4: "shiftp4",
  SHIFT_P5: "shiftp5",
};

export const SSD_VOLUME_SOURCE_KEY = {
  PICK_2_REBIN_PNYP: "pick2rebinpnyp",
  PICK_2_REBIN_PP: "pick2rebinpp",
  PICK_2_REBIN_PENDING_CHARGE: "pick2rebinpendingcharge",
  PICK_2_REBIN_SORTED: "pick2rebinsorted",
  VNA_PNYP: "vnapnyp",
  VNA_PP: "vnapp",
  VNA_PENDING_CHARGE: "vnapendingcharge",
  VNA_SORTED: "vnasorted",
  SINGLES_PNYP: "singlespnyp",
  SINGLES_PP: "singlespp",
  SINGLES_PENDING_CHARGE: "singlespendingcharge",
  SINGLES_SORTED: "singlessorted",
  ROLLED: "rolled",
  RTS: "rts",
  HELD: "held",
  INJECTION: "injection",
  OUTBOUND: "outbound",
  MANIFEST_PENDING: "manifestpending",
};

export const SSD_VOLUME_SOURCE_TYPE = {
  VOLUME_SOURCE: "volume_source",
  ROLE: "role",
};

export const SSD_DEPARTMENT_NAME = {
  OUTBOUND: "outbound",
  SORTATION: "sortation",
  INJECTION: "injection",
};

export const SSD_PROCESS_NAME = {
  PACK: "pack",
  PICK: "pick",
};

export const SSD_VOLUME_TYPE = {
  UNITS: "units",
  PACKAGES: "packages",
};

export const SSD_ROLE_NAME = {
  // core - 5H process roles
  PICK_2_REBIN_PACK: "pick2rebinpack",
  PICK_2_REBIN_PICK: "pick2rebinpick",
  SINGLES_PACK: "singlespack",
  SINGLES_PICK: "singlespick",
  VNA_PACK: "vnapack",
  VNA_PICK: "vnapick",
  UNLOAD: "unload",
  STOW: "stow",
  BUFFER: "buffer",
  INDUCT: "induct",
  STAGE: "stage",
  RTS: "rts",
  SORTATION_PROBLEM_SOLVE: "sortationproblemsolve",
  OUTBOUND_PROBLEM_SOLVE: "outboundproblemsolve",
  PROCESS_ASSISTANT: "processassistant",
  SPOTTER: "spotter",
  EMPTY_CART_RETURN: "emptycartreturn",
  LINE_STRAIGHTENER: "linestraightener",
  AUTO_SAL_PROBLEM_SOLVER: "autosalproblemsolver",
  AUTO_SORT_PROBLEM_SOLVER: "autosortproblemsolver",
  MANUAL_INDUCT: "waterspider",
  FLOATING_STOW: "floatingstower",
  ROUTE_PRIORITIZATION: "routeprioritization",
  // core - rush 3H process roles
  PICK_2_REBIN_PACK_3H: "pick2rebinpack_three_hour",
  PICK_2_REBIN_PICK_3H: "pick2rebinpick_three_hour",
  SINGLES_PACK_3H: "singlespack_three_hour",
  SINGLES_PICK_3H: "singlespick_three_hour",
  VNA_PACK_3H: "vnapack_three_hour",
  VNA_PICK_3H: "vnapick_three_hour",
  UNLOAD_3H: "unload_three_hour",
  STOW_3H: "stow_three_hour",
  BUFFER_3H: "buffer_three_hour",
  INDUCT_3H: "induct_three_hour",
  STAGE_3H: "stage_three_hour",
  // core - rush 1H process roles
  PICK_2_REBIN_PACK_CORE_1H: "pick2rebinpack_core_premium",
  PICK_2_REBIN_PICK_CORE_1H: "pick2rebinpick_core_premium",
  SINGLES_PACK_CORE_1H: "singlespack_core_premium",
  SINGLES_PICK_CORE_1H: "singlespick_core_premium",
  VNA_PACK_CORE_1H: "vnapack_core_premium",
  VNA_PICK_CORE_1H: "vnapick_core_premium",
  UNLOAD_CORE_1H: "unload_core_premium",
  STOW_CORE_1H: "stow_core_premium",
  BUFFER_CORE_1H: "buffer_core_premium",
  INDUCT_CORE_1H: "induct_core_premium",
  STAGE_CORE_1H: "stage_core_premium",
  WATER_SPIDER_CORE_1H: "waterspider_core_premium",
  // grocery - 5H process roles
  PICK_GROCERY_AMBIENT: "pick_grocery_ambient",
  PICK_GROCERY_CHILLED: "pick_grocery_chilled",
  PICK_GROCERY_FROZEN: "pick_grocery_frozen",
  SLAM_GROCERY: "slam_grocery",
  INDUCT_GROCERY: "induct_grocery",
  STOW_GROCERY: "stow_grocery",
  BATCHING_GROCERY: "batching_grocery",
  // grocery - rush 3H process roles
  PICK_GROCERY_AMBIENT_3H: "pick_grocery_ambient_three_hour",
  PICK_GROCERY_CHILLED_3H: "pick_grocery_chilled_three_hour",
  PICK_GROCERY_FROZEN_3H: "pick_grocery_frozen_three_hour",
  SLAM_GROCERY_3H: "slam_grocery_three_hour",
  INDUCT_GROCERY_3H: "induct_grocery_three_hour",
  STOW_GROCERY_3H: "stow_grocery_three_hour",
  BATCHING_GROCERY_3H: "batching_grocery_three_hour",
  // grocery - rush 1H process roles
  PICK_GROCERY_AMBIENT_1H: "pick_grocery_ambient_premium",
  PICK_GROCERY_CHILLED_1H: "pick_grocery_chilled_premium",
  PICK_GROCERY_FROZEN_1H: "pick_grocery_frozen_premium",
  SLAM_GROCERY_1H: "slam_grocery_premium",
  INDUCT_GROCERY_1H: "induct_grocery_premium",
  STOW_GROCERY_1H: "stow_grocery_premium",
  BATCHING_GROCERY_1H: "batching_grocery_premium",
  WATER_SPIDER_GROCERY_1H: "waterspider_grocery_premium",
};

export const SSD_ROLE = {
  [SSD_ROLE_NAME.PICK_2_REBIN_PICK]: {
    roleName: SSD_ROLE_NAME.PICK_2_REBIN_PICK,
    roleLabel: "Pick2Rebin Pick",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.PICK_2_REBIN_PNYP,
        delayInSeconds: 0,
        conversion: 1,
      },
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.PICK_2_REBIN_PENDING_CHARGE,
        delayInSeconds: 0,
        conversion: 1,
      },
    ],
    order: 0,
    isDirectRole: true,
    volumeType: SSD_VOLUME_TYPE.UNITS,
  },
  [SSD_ROLE_NAME.PICK_2_REBIN_PACK]: {
    roleName: SSD_ROLE_NAME.PICK_2_REBIN_PACK,
    roleLabel: "Pick2Rebin Pack",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.PICK_2_REBIN_SORTED,
        delayInSeconds: 0,
        conversion: 1,
      },
    ],
    order: 1,
    isDirectRole: true,
    volumeType: SSD_VOLUME_TYPE.UNITS,
  },
  [SSD_ROLE_NAME.SINGLES_PICK]: {
    roleName: SSD_ROLE_NAME.SINGLES_PICK,
    roleLabel: "Singles Pick",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.SINGLES_PNYP,
        delayInSeconds: 0,
        conversion: 1,
      },
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.SINGLES_PENDING_CHARGE,
        delayInSeconds: 0,
        conversion: 1,
      },
    ],
    order: 2,
    isDirectRole: true,
    volumeType: SSD_VOLUME_TYPE.UNITS,
  },
  [SSD_ROLE_NAME.SINGLES_PACK]: {
    roleName: SSD_ROLE_NAME.SINGLES_PACK,
    roleLabel: "Singles Pack",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.SINGLES_SORTED,
        delayInSeconds: 0,
        conversion: 1,
      },
    ],
    order: 3,
    isDirectRole: true,
    volumeType: SSD_VOLUME_TYPE.UNITS,
  },
  [SSD_ROLE_NAME.VNA_PICK]: {
    roleName: SSD_ROLE_NAME.VNA_PICK,
    roleLabel: "VNA Pick",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.VNA_PNYP,
        delayInSeconds: 0,
        conversion: 1,
      },
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.VNA_PENDING_CHARGE,
        delayInSeconds: 0,
        conversion: 1,
      },
    ],
    order: 4,
    isDirectRole: true,
    volumeType: SSD_VOLUME_TYPE.UNITS,
  },
  [SSD_ROLE_NAME.VNA_PACK]: {
    roleName: SSD_ROLE_NAME.VNA_PACK,
    roleLabel: "VNA Pack",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.VNA_SORTED,
        delayInSeconds: 0,
        conversion: 1,
      },
    ],
    order: 5,
    isDirectRole: true,
    volumeType: SSD_VOLUME_TYPE.UNITS,
  },
  [SSD_ROLE_NAME.OUTBOUND_PROBLEM_SOLVE]: {
    roleName: SSD_ROLE_NAME.OUTBOUND_PROBLEM_SOLVE,
    roleLabel: "Outbound Problem Solve",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 6,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.UNLOAD]: {
    roleName: SSD_ROLE_NAME.UNLOAD,
    roleLabel: "Unload",
    departmentName: SSD_DEPARTMENT_NAME.INJECTION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: SSD_VOLUME_TYPE.PACKAGES,
  },
  [SSD_ROLE_NAME.INDUCT]: {
    roleName: SSD_ROLE_NAME.INDUCT,
    roleLabel: "Induct",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.HELD,
        delayInSeconds: 0,
        conversion: 1,
      },
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.ROLLED,
        delayInSeconds: 0,
        conversion: 1,
      },
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.MANIFEST_PENDING,
        delayInSeconds: 0,
        conversion: 1,
      },
      {
        sourceType: SSD_VOLUME_SOURCE_TYPE.VOLUME_SOURCE,
        sourceKey: SSD_VOLUME_SOURCE_KEY.RTS,
        delayInSeconds: 0,
        conversion: 1,
      },
    ],
    order: 0,
    isDirectRole: true,
    volumeType: SSD_VOLUME_TYPE.PACKAGES,
  },
  [SSD_ROLE_NAME.BUFFER]: {
    roleName: SSD_ROLE_NAME.BUFFER,
    roleLabel: "Buffer",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 1,
    isDirectRole: false,
    volumeType: SSD_VOLUME_TYPE.PACKAGES,
  },
  [SSD_ROLE_NAME.STOW]: {
    roleName: SSD_ROLE_NAME.STOW,
    roleLabel: "Stow",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 2,
    isDirectRole: true,
    volumeType: SSD_VOLUME_TYPE.PACKAGES,
  },
  [SSD_ROLE_NAME.STAGE]: {
    roleName: SSD_ROLE_NAME.STAGE,
    roleLabel: "Stage",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 3,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.RTS]: {
    roleName: SSD_ROLE_NAME.RTS,
    roleLabel: "RTS",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 4,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SORTATION_PROBLEM_SOLVE]: {
    roleName: SSD_ROLE_NAME.SORTATION_PROBLEM_SOLVE,
    roleLabel: "Sortation Problem Solve",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 5,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.EMPTY_CART_RETURN]: {
    roleName: SSD_ROLE_NAME.EMPTY_CART_RETURN,
    roleLabel: "Empty Cart Return",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 6,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PROCESS_ASSISTANT]: {
    roleName: SSD_ROLE_NAME.PROCESS_ASSISTANT,
    roleLabel: "Process Assistant",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 8,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SPOTTER]: {
    roleName: SSD_ROLE_NAME.SPOTTER,
    roleLabel: "Spotter (Cart Return)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 7,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.LINE_STRAIGHTENER]: {
    roleName: SSD_ROLE_NAME.LINE_STRAIGHTENER,
    roleLabel: "Line Straightener",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 9,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.AUTO_SAL_PROBLEM_SOLVER]: {
    roleName: SSD_ROLE_NAME.AUTO_SAL_PROBLEM_SOLVER,
    roleLabel: "Auto SAL Problem Solver",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 10,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.AUTO_SORT_PROBLEM_SOLVER]: {
    roleName: SSD_ROLE_NAME.AUTO_SORT_PROBLEM_SOLVER,
    roleLabel: "Auto Sort Problem Solver",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 11,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.MANUAL_INDUCT]: {
    roleName: SSD_ROLE_NAME.MANUAL_INDUCT,
    roleLabel: "Manual Induct",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 12,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.FLOATING_STOW]: {
    roleName: SSD_ROLE_NAME.FLOATING_STOW,
    roleLabel: "Floating Stow",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: "core",
    speed: "5H",
    volumesToProcess: [],
    order: 7,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SPOTTER]: {
    roleName: SSD_ROLE_NAME.SPOTTER,
    roleLabel: "Spotter (Cart Return)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 7,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.ROUTE_PRIORITIZATION]: {
    roleName: SSD_ROLE_NAME.ROUTE_PRIORITIZATION,
    roleLabel: "Route Prioritization",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 9,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_GROCERY_AMBIENT]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_AMBIENT,
    roleLabel: "Ambient Pick (Grocery)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_GROCERY_CHILLED]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_CHILLED,
    roleLabel: "Chilled Pick (Grocery)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_GROCERY_FROZEN]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_FROZEN,
    roleLabel: "Frozen Pick (Grocery)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SLAM_GROCERY]: {
    roleName: SSD_ROLE_NAME.SLAM_GROCERY,
    roleLabel: "Slam (Grocery)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 1,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.INDUCT_GROCERY]: {
    roleName: SSD_ROLE_NAME.INDUCT_GROCERY,
    roleLabel: "Induct (Grocery)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 2,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.STOW_GROCERY]: {
    roleName: SSD_ROLE_NAME.STOW_GROCERY,
    roleLabel: "Stow (Grocery)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 3,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.BATCHING_GROCERY]: {
    roleName: SSD_ROLE_NAME.BATCHING_GROCERY,
    roleLabel: "Batching (Grocery)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.FIVE_HOUR,
    volumesToProcess: [],
    order: 4,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_2_REBIN_PICK_3H]: {
    roleName: SSD_ROLE_NAME.PICK_2_REBIN_PICK_3H,
    roleLabel: "Pick2Rebin Pick (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_2_REBIN_PACK_3H]: {
    roleName: SSD_ROLE_NAME.PICK_2_REBIN_PACK_3H,
    roleLabel: "Pick2Rebin Pack (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 1,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SINGLES_PICK_3H]: {
    roleName: SSD_ROLE_NAME.SINGLES_PICK_3H,
    roleLabel: "Singles Pick (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 2,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SINGLES_PACK_3H]: {
    roleName: SSD_ROLE_NAME.SINGLES_PACK_3H,
    roleLabel: "Singles Pack (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 3,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.VNA_PICK_3H]: {
    roleName: SSD_ROLE_NAME.VNA_PICK_3H,
    roleLabel: "VNA Pick (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 4,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.VNA_PACK_3H]: {
    roleName: SSD_ROLE_NAME.VNA_PACK_3H,
    roleLabel: "VNA Pack (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 5,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.UNLOAD_3H]: {
    roleName: SSD_ROLE_NAME.UNLOAD_3H,
    roleLabel: "Unload (3H)",
    departmentName: SSD_DEPARTMENT_NAME.INJECTION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 1,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.INDUCT_3H]: {
    roleName: SSD_ROLE_NAME.INDUCT_3H,
    roleLabel: "Induct (3H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 13,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.BUFFER_3H]: {
    roleName: SSD_ROLE_NAME.BUFFER_3H,
    roleLabel: "Buffer (3H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 14,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.STOW_3H]: {
    roleName: SSD_ROLE_NAME.STOW_3H,
    roleLabel: "Stow (3H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 15,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.STAGE_3H]: {
    roleName: SSD_ROLE_NAME.STAGE_3H,
    roleLabel: "Stage (3H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 16,
    isDirectRole: false,
    volumeType: null,
  },
  // rush grocery roles
  [SSD_ROLE_NAME.PICK_GROCERY_AMBIENT_3H]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_AMBIENT_3H,
    roleLabel: "Ambient Pick (Grocery) (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_GROCERY_CHILLED_3H]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_CHILLED_3H,
    roleLabel: "Chilled Pick (Grocery) (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_GROCERY_FROZEN_3H]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_FROZEN_3H,
    roleLabel: "Frozen Pick (Grocery) (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SLAM_GROCERY_3H]: {
    roleName: SSD_ROLE_NAME.SLAM_GROCERY_3H,
    roleLabel: "Slam (Grocery) (3H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 1,
    isDirectRole: null,
    volumeType: null,
  },
  [SSD_ROLE_NAME.INDUCT_GROCERY_3H]: {
    roleName: SSD_ROLE_NAME.INDUCT_GROCERY_3H,
    roleLabel: "Induct (Grocery) (3H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 2,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.STOW_GROCERY_3H]: {
    roleName: SSD_ROLE_NAME.STOW_GROCERY_3H,
    roleLabel: "Stow (Grocery) (3H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 3,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.BATCHING_GROCERY_3H]: {
    roleName: SSD_ROLE_NAME.BATCHING_GROCERY_3H,
    roleLabel: "Batching (Grocery) (3H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.THREE_HOUR,
    volumesToProcess: [],
    order: 4,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_2_REBIN_PICK_CORE_1H]: {
    roleName: SSD_ROLE_NAME.PICK_2_REBIN_PICK_CORE_1H,
    roleLabel: "Pick2Rebin Pick (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_2_REBIN_PACK_CORE_1H]: {
    roleName: SSD_ROLE_NAME.PICK_2_REBIN_PACK_CORE_1H,
    roleLabel: "Pick2Rebin Pack (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SINGLES_PICK_CORE_1H]: {
    roleName: SSD_ROLE_NAME.SINGLES_PICK_CORE_1H,
    roleLabel: "Singles Pick (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SINGLES_PACK_CORE_1H]: {
    roleName: SSD_ROLE_NAME.SINGLES_PACK_CORE_1H,
    roleLabel: "Singles Pack (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 3,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.VNA_PICK_CORE_1H]: {
    roleName: SSD_ROLE_NAME.VNA_PICK_CORE_1H,
    roleLabel: "VNA Pick (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PICK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 4,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.VNA_PACK_CORE_1H]: {
    roleName: SSD_ROLE_NAME.VNA_PACK_CORE_1H,
    roleLabel: "VNA Pack (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: SSD_PROCESS_NAME.PACK,
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 5,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.UNLOAD_CORE_1H]: {
    roleName: SSD_ROLE_NAME.UNLOAD_CORE_1H,
    roleLabel: "Unload (1H)",
    departmentName: SSD_DEPARTMENT_NAME.INJECTION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 1,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.INDUCT_CORE_1H]: {
    roleName: SSD_ROLE_NAME.INDUCT_CORE_1H,
    roleLabel: "Induct (1H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 13,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.STOW_CORE_1H]: {
    roleName: SSD_ROLE_NAME.STOW_CORE_1H,
    roleLabel: "Stow (1H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 15,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.BUFFER_CORE_1H]: {
    roleName: SSD_ROLE_NAME.BUFFER_CORE_1H,
    roleLabel: "Buffer (1H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 14,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.STAGE_CORE_1H]: {
    roleName: SSD_ROLE_NAME.STAGE_CORE_1H,
    roleLabel: "Stage (1H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 16,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.WATER_SPIDER_CORE_1H]: {
    roleName: SSD_ROLE_NAME.WATER_SPIDER_CORE_1H,
    roleLabel: "Water Spider (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.CORE,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 17,
    isDirectRole: false,
    volumeType: null,
  },
  // 1H Premium Grocery Roles
  [SSD_ROLE_NAME.PICK_GROCERY_AMBIENT_1H]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_AMBIENT_1H,
    roleLabel: "Ambient Pick (Grocery) (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_GROCERY_CHILLED_1H]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_CHILLED_1H,
    roleLabel: "Chilled Pick (Grocery) (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.PICK_GROCERY_FROZEN_1H]: {
    roleName: SSD_ROLE_NAME.PICK_GROCERY_FROZEN_1H,
    roleLabel: "Frozen Pick (Grocery) (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.SLAM_GROCERY_1H]: {
    roleName: SSD_ROLE_NAME.SLAM_GROCERY_1H,
    roleLabel: "Slam (Grocery) (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 1,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.INDUCT_GROCERY_1H]: {
    roleName: SSD_ROLE_NAME.INDUCT_GROCERY_1H,
    roleLabel: "Induct (Grocery) (1H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 0,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.STOW_GROCERY_1H]: {
    roleName: SSD_ROLE_NAME.STOW_GROCERY_1H,
    roleLabel: "Stow (Grocery) (1H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 1,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.BATCHING_GROCERY_1H]: {
    roleName: SSD_ROLE_NAME.BATCHING_GROCERY_1H,
    roleLabel: "Batching (Grocery) (1H)",
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 2,
    isDirectRole: false,
    volumeType: null,
  },
  [SSD_ROLE_NAME.WATER_SPIDER_GROCERY_1H]: {
    roleName: SSD_ROLE_NAME.WATER_SPIDER_GROCERY_1H,
    roleLabel: "Water Spider (Grocery) (1H)",
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    processName: "",
    businessType: BUSINESS_TYPES.GROCERY,
    speed: SPEED_TYPES.ONE_HOUR,
    volumesToProcess: [],
    order: 3,
    isDirectRole: false,
    volumeType: null,
  },
};

export const SSD_DEPARTMENT = {
  [SSD_DEPARTMENT_NAME.OUTBOUND]: {
    departmentName: SSD_DEPARTMENT_NAME.OUTBOUND,
    departmentLabel: "Outbound",
  },
  [SSD_DEPARTMENT_NAME.SORTATION]: {
    departmentName: SSD_DEPARTMENT_NAME.SORTATION,
    departmentLabel: "Sortation",
  },
  [SSD_DEPARTMENT_NAME.INJECTION]: {
    departmentName: SSD_DEPARTMENT_NAME.INJECTION,
    departmentLabel: "Injection",
  },
};

export const SSD_DELIVERY_WINDOW = {
  BEDTIME: "Bedtime",
  BREAKFAST: "Breakfast",
  BRUNCH: "Brunch",
  LUNCH: "Lunch",
  DINNER: "Dinner",
};

export const SSD_RULE_CATEGORY = {
  DEMAND: "demand",
  RULE: "rule",
};

export const SSD_RULE_TYPE = {
  RATE_BASED: "rate_based",
  MIN_HEADCOUNT: "min_headcount",
  MAX_HEADCOUNT: "max_headcount",
  VOLUME_RATIO: "volume_ratio",
  ROLE_RATIO: "role_ratio",
};

export const SSD_RULE = {
  RATE_BASED: {
    category: SSD_RULE_CATEGORY.DEMAND,
    type: SSD_RULE_TYPE.RATE_BASED,
  },
  MIN_HEADCOUNT: {
    category: SSD_RULE_CATEGORY.RULE,
    type: SSD_RULE_TYPE.MIN_HEADCOUNT,
  },
  MAX_HEADCOUNT: {
    category: SSD_RULE_CATEGORY.RULE,
    type: SSD_RULE_TYPE.MAX_HEADCOUNT,
  },
  ROLE_RATIO: {
    category: SSD_RULE_CATEGORY.RULE,
    type: SSD_RULE_TYPE.ROLE_RATIO,
  },
  VOLUME_RATIO: {
    category: SSD_RULE_CATEGORY.RULE,
    type: SSD_RULE_TYPE.VOLUME_RATIO,
  },
};

export const SSD_DAY_OF_WEEK_CONFIGURATION_ENABLED_ROLES = [
  SSD_ROLE_NAME.STAGE,
];

export const CORE_BUSINESS_TYPE_LABEL = "SSD";

export const BUSINESS_VIEW_NAME = {
  CORE: "core",
  GROCERY: "grocery",
};



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/SettingsConstant.js